import {suggestionStyles} from "@insite/content-library/Widgets/ProductList/ProductListSuggestion";
import { css } from "styled-components";

suggestionStyles.wrapper = {
    css: css`
        padding: 0 15px;
    `
}